module.exports = __webpack_public_path__ + "img/success.cd75e1a6.png";